<template>
  <div class="customer-banner">
    <el-carousel
      :interval="3000"
      @change="onChangeBanner"
      height="360px"
      v-if="bannerList.length"
    >
      <el-carousel-item
        v-for="item in bannerList"
        :key="item.id"
      >
        <h3
          :class="{
          'canClick':
          item.link_url}"
          @click="goLink(item.link_url)"
        ><img
            v-show="currentPath === 'home'"
            :src="item.picture"
            alt="banner"
          >
          <img
            v-show="currentPath === 'customer'"
            src="@/assets/images/customer/banner1.png"
            alt="banner"
          >
        </h3>
      </el-carousel-item>
    </el-carousel>
    <div class="banner-btn">
      <div
        class="btn-item"
        v-for="(item, index) in bannerList.length"
        :class="{currentItem: currentIndex===index}"
        :key="item"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: 0,
      bannerList: [],

      currentPath: "home",
    };
  },
  created() {
    this.getBannderList();
  },
  mounted() {
    this.destroyedNativeBtn();
  },
  watch: {
    "$route.path": {
      handler(nv) {
        if (nv.includes("videodetail")) {
          this.currentPath = "customer";
        } else {
          this.currentPath = "home";
        }
      },
      immediate: true,
    },
  },
  methods: {
    goLink(link) {
      if (link) {
        return (window.location.href = link);
      } else {
        return;
      }
    },
    getBannderList() {
      let success = (res) => {
        let result = res.data;
        this.bannerList = result.map((item) => {
          item.picture = item.picture.includes("http")
            ? item.picture
            : this.BASE_URL + item.picture;
          return item;
        });
      };
      let params = {
        module: 6,
      };
      this.$ajax.get("/api/carousel/manage_banners", { params, func: { success } });
    },
    destroyedNativeBtn() {
      //  销毁原生组件轮播图的切换按钮，防止触发其事件
      let btnArr = document.getElementsByClassName("el-carousel__indicators");
      for (let i = 0; i < btnArr.length; i++) {
        btnArr[i].remove();
      }
    },
    onChangeBanner(value) {
      this.currentIndex = value;
    },
  },
};
</script>

<style scoped lang='scss'>
.customer-banner {
  position: relative;
  width: 100%;
  min-height: 20px;
  background-color: #fff;
  &::after {
    z-index: 98;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 20px;
    display: block;
    background: linear-gradient(
        -45deg,
        transparent 33.33%,
        #fff 33.33%,
        #fff 66.666%,
        transparent 66.666%
      ),
      linear-gradient(
        45deg,
        transparent 33.33%,
        #fff 33.33%,
        #fff 66.666%,
        transparent 66.666%
      );
    background-size: 12px 60px;
    transform: rotate(180deg);
  }

  .banner-btn {
    z-index: 1;
    height: 8px;
    width: 80px;
    border-radius: 4px;
    display: flex;
    justify-content: space-around;
    position: absolute;
    bottom: 1.2rem;
    left: calc(50% - 40px);

    .btn-item {
      background-color: #cbcbcb;
      height: 6px;
      width: 6px;
      border-radius: 6px;
    }
    .currentItem {
      width: 20px;
      background: #fff;
    }
  }
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  line-height: 300px;
  height: 100%;
  width: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
}
.canClick {
  &:hover {
    cursor: pointer;
  }
}

:deep(.el-carousel__item.is-active) {
  z-index: 0;
}
:deep(.el-carousel__arrow ){
  z-index: 1;
}

:deep( .el-carousel__button ){
  display: none;
  pointer-events: none;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>
